define ['./landing.scss'], () ->
  ($scope, $timeout, $state, $location, $anchorScroll, content, $window) ->
    $scope.current_report = 'credit'
    $scope.current_frame = 0
    $scope.interval_width = 1/15

    $scope.toggle_report = (type) -> 
      $scope.current_report = type

    angular.element($window).bind("scroll", (e) ->
      console.log($scope.in_view('.better-tenants-container'))
      if $scope.in_view('.better-tenants-container') and $scope.current_frame == 0
        $scope.start_video()
    )

    angular.element($window).bind("touchmove", (e) ->
      console.log($scope.in_view('.better-tenants-container'))
      if $scope.in_view('.better-tenants-container') and $scope.current_frame == 0
        $scope.start_video()
    )

    $scope.in_view = (el) ->
      docViewTop = $(window).scrollTop()
      docViewBottom = docViewTop + $(window).height()

      elemTop = $(el).offset().top
      elemBottom = elemTop + $(el).height()

      return elemTop <= docViewBottom
    
    $scope.restart_video = () ->
      $scope.current_frame = 0
      $('.first-bar')[0].style.width = "0%"
      $('.second-bar')[0].style.width = "0%"
      $scope.start_video()

    $scope.start_video = () ->
      interval = setInterval(() ->
        if $scope.current_frame > 3000
          clearInterval(interval)
          $scope.restart_video()
        if $scope.current_frame <= 1500
          $('.first-bar')[0].style.width = "#{($scope.current_frame / 1500 * 100.0)}%"
        if $scope.current_frame > 1500
          $('.second-bar')[0].style.width = "#{(($scope.current_frame - 1500) / 1500 * 100.0)}%"
        
        $scope.current_frame++
      , 10);
      
    



// WEBPACK FOOTER //
// ./components/bare_home/new_landing.coffee